import Controller from './Controller';
import type Report from '../checks/Report';
import { CEMC_Dependency } from '../commands/metamodel/complex/index';
import { Combined_DeleteDependency } from '../commands/combined';
import type { OrId, DependencyUpdates } from '../commands/types';
import type { IDependency } from '../../stores/model/metamodel/dependency';

/**
 * Edit or delete a dependency
 */
export default class EditDependencyController extends Controller {
  async editDependency(id: OrId<IDependency>, updates: DependencyUpdates): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = CEMC_Dependency(model, id, updates);
      return checks;
    });
  }

  async deleteDependency(id: OrId<IDependency>): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = Combined_DeleteDependency(model, id);
      return checks;
    });
  }
}
